import { useCallback, useState } from 'react';

// Inline form validation: the message sits under its field, the field is marked
// aria-invalid and described by the message, and it receives focus.
export function useFieldErrors() {
    const [errors, setErrors] = useState({});

    const fail = useCallback((id, message) => {
        setErrors({ [id]: message });
        requestAnimationFrame(() => document.getElementById(id)?.focus());
        return false;
    }, []);

    const clearError = useCallback((id) => {
        setErrors(prev => (prev[id] ? { ...prev, [id]: undefined } : prev));
    }, []);

    const resetErrors = useCallback(() => setErrors({}), []);

    const fieldProps = (id) => ({
        'aria-invalid': errors[id] ? true : undefined,
        'aria-describedby': errors[id] ? `${id}-error` : undefined,
    });

    return { errors, fail, clearError, resetErrors, fieldProps };
}
